<script>
import { SingleImageElementMixin } from "%/dynamic-component-editor/standard-elements/image-element/single-image-element-mixin";
import BaseImageElement
  from "%/dynamic-component-editor/standard-elements/image-element/BaseImageElement.vue";

export default {
  name: "ImageElement",
  extends: BaseImageElement,
  elementPanelSettings: {
    tags: ["image", "media", "photo", "picture"],
    displayName: "Image",
    elementGroup: "general",
    displayIcon: "image",
    elementType: "element",
  },
  mixins: [SingleImageElementMixin],
};
</script>

<style lang="scss" scoped>
</style>
